/**
 * Axios instance for Express backend proxy calls.
 * Includes the API key header for authentication.
 */
import axios from "axios";

const PROXY_HOST = process.env.VUE_APP_EXPRESS_PROXY_URL || 'http://localhost:3001';
const API_KEY = process.env.VUE_APP_EXPRESS_API_KEY || '';

const axiosProxy = axios.create({
  baseURL: PROXY_HOST,
  headers: {
    'x-api-key': API_KEY,
  },
});

export default axiosProxy;
export { PROXY_HOST, API_KEY };
